<template lang="pug">
.k-tour-rewards.brand-dark-blue.relative
  k-container
    v-row(align="center" justify="start")
      v-col(sm="6" cols="12")
        k-img(:sqip="require('~images/dashboard.png?sqip')" height="200" width="400" contain).k-tour-rewards__image.hidden-xs-only
      v-col(sm="6" cols="12").white--text
        .k-tour-rewards__title.title--36.mb-5.font-weight-bold.font-family--secondary Become a Kintell Advisor
        .paragraph.mb-10 Join our wonderful community of advisors and make full use of your skills and knowledge. Applying is quick and easy, with our streamlined vetting process meaning we can often approve new advisors in hours.
        .pb-10
          div(v-for="point in points")
            .d-inline-flex.align-center
              k-icon(size="13").pr-10 check
              .white--text.paragraph {{ point }}
        k-button(color="primary" :to="userIsAuthenticated ? '/my-kintell/kintell-cards' : '/join-now'" responsive).ma-0 Become an advisor
</template>

<script>
import { UsesAuthenticatedUser } from '@/mixins'

export default {
  mixins: [ UsesAuthenticatedUser ],
  computed: {
    points () {
      return [
        'Earn money in your spare time',
        'Make use of your untapped knowledge',
        'Work hours that suit you',
        'Use Kintell to make private bookings',
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.k-tour-rewards {
  overflow: hidden;

  padding: 50px 0;

  @include sm-and-down {
    padding: 10px 0;
  }

  &__image {
    height: 100% !important;
    left: 0;
    max-width: 607px;
    position: absolute;
    top: 0;
    width: 40% !important;

    @include sm-and-down {
      left: 0;
    }
  }
}
</style>

